module.exports = __webpack_public_path__ + "media/images/talent/feature-04-2911e56d769ced6520917d34d39a1de0.svg";